import { createSlice } from "@reduxjs/toolkit";

const holidayCalendarSlice = createSlice({
    name: "holidayCalendar",
    initialState: {
        isLoading: false,
        currentHoliday: {},
        currentCalendar: {},
        holidayGroup: [],
        holidayCalendar: [],
        employeeList: [],
        employeeByCompany:[]
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setCurrentHoliday(state, action) {
            state.currentHoliday = action.payload;
        },
        setCurrentCalendar(state, action) {
            state.currentCalendar = action.payload;
        },
        setHolidayGroup(state, action) {
            state.holidayGroup = action.payload;
        },
        setHolidayCalendar(state, action) {
            state.holidayCalendar = action.payload;
        },
        setEmployeeList(state, action) {
            state.employeeList = action.payload;
        },
        setEmployeeByCompany(state, action) {
            state.employeeByCompany = action.payload;
        }
    },
});

export const {
    setIsLoading,
    setCurrentHoliday,
    setCurrentCalendar,
    setHolidayGroup,
    setHolidayCalendar,
    setEmployeeList,
    setEmployeeByCompany
} = holidayCalendarSlice.actions;
export default holidayCalendarSlice.reducer;
